import React, { useState, useEffect } from 'react';

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import { getUTCDateDiffInSeconds } from '@/utils/helpers';

type SessionNotificationProps = {
  open: boolean;
  onClose: () => void;
  expiresAt?: string;
  onRefreshSession: () => void;
}

export default function SessionNotification(props: SessionNotificationProps) {
  const { open, onClose, expiresAt, onRefreshSession } = props;
  const [ timeLeft, setTimeLeft ] = useState<number>(0);

  useEffect(() => {
    if (expiresAt) {
      const timeRemainingInSeconds = getUTCDateDiffInSeconds(new Date(), new Date(expiresAt));
      setTimeLeft(timeRemainingInSeconds);
    }
  }, [expiresAt]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);
    return () => clearTimeout(timer);
  });

  const remainingTimeInMinutes = Math.floor(timeLeft / 60);
  const remainingTimeInSeconds = timeLeft % 60;
  const remainingTime = `${remainingTimeInMinutes} minutes ${remainingTimeInSeconds ? `and ${remainingTimeInSeconds} seconds` : ''}`;

  return (
    <Snackbar open={open}>
      <MuiAlert onClose={onClose} severity="info" variant="filled" className="text-gray-800 bg-yellow-300">
        Hey there! Please <button className="font-semibold underline" onClick={onRefreshSession}>log in again</button> to continue working so you don't lose your progress.  Timeout in { remainingTime }.
      </MuiAlert>
    </Snackbar>
  );
};
